import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SzerkZar } from './szerk-zar.service';

/**
 *  `<app-szerk-zar-sav [zar]="zar">` – a szerkesztő tetején: ki szerkeszti most a rekordot, ha nem mi;
 *  ha közben elveszett a zár, újratöltés; átvétel a saját másik ablakunkból. Ha a zár a miénk, nem látszik.
 */
@Component({
  selector: 'app-szerk-zar-sav',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="szz" *ngIf="zar && (zar.allapot === 'masnal' || zar.allapot === 'elveszett' || zar.allapot === 'hiba' || zar.allapot === 'kerem')"
         [class.figy]="zar.allapot === 'elveszett'" [class.halk]="zar.allapot === 'hiba' || zar.allapot === 'kerem'" role="status">
      <ng-container [ngSwitch]="zar.allapot">
        <ng-container *ngSwitchCase="'masnal'">
          <span class="ikon" aria-hidden="true">🔒</span>
          <span class="szoveg">
            <ng-container *ngIf="zar.foglalo?.sajat; else mas">Ezt <b>te</b> szerkeszted egy másik ablakban vagy eszközön{{ ota }}.</ng-container>
            <ng-template #mas><b>{{ zar.foglalo?.nev || 'Egy másik felhasználó' }}</b> szerkeszti{{ ota }}.</ng-template>
            Most csak megtekintheted; ha befejezi, magától szerkeszthetővé válik.
            <small *ngIf="zar.uzenet">{{ zar.uzenet }}</small>
          </span>
          <button type="button" class="gomb" *ngIf="zar.foglalo?.sajat" (click)="zar.atvesz()">Szerkesztés itt</button>
          <button type="button" class="link" *ngIf="!zar.foglalo?.sajat" (click)="zar.atvesz()" title="A modul adminja átveheti, ha a szerkesztő elérhetetlen">Átvétel (admin)</button>
        </ng-container>
        <ng-container *ngSwitchCase="'elveszett'">
          <span class="ikon" aria-hidden="true">⚠</span>
          <span class="szoveg">Ezt közben más is megnyitotta szerkesztésre, ezért a képernyőn lévő adat már nem biztos, hogy friss.
            A mentéshez töltsd be újra.</span>
          <button type="button" class="gomb" *ngIf="zar.ujratolt" (click)="ujratolt()">Újratöltés</button>
        </ng-container>
        <ng-container *ngSwitchCase="'hiba'">
          <span class="szoveg">{{ zar.uzenet || 'A szerkesztési zár most nem érhető el – próbálkozom.' }}</span>
        </ng-container>
        <ng-container *ngSwitchCase="'kerem'">
          <span class="szoveg">Szerkesztési zár kérése…</span>
        </ng-container>
      </ng-container>
    </div>`,
  styles: [`
    :host { display: block; }
    .szz { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; margin: 0 0 10px; padding: 8px 12px;
           border-radius: 8px; font-size: 13px; line-height: 1.4;
           background: rgba(var(--ion-color-warning-rgb, 247, 144, 9), .14);
           border: 1px solid rgba(var(--ion-color-warning-rgb, 247, 144, 9), .45);
           color: var(--ion-text-color, #101828); }
    .szz.figy { background: rgba(var(--ion-color-danger-rgb, 180, 35, 24), .10);
                border-color: rgba(var(--ion-color-danger-rgb, 180, 35, 24), .45); }
    .szz.halk { background: transparent; border-style: dashed; border-color: var(--ion-color-step-300, #d0d5dd);
                color: var(--ion-color-medium, #667085); }
    .ikon { font-size: 16px; }
    .szoveg { flex: 1 1 260px; }
    .szoveg small { display: block; color: var(--ion-color-medium, #667085); }
    .gomb { border: 0; border-radius: 6px; padding: 6px 12px; font-weight: 600; cursor: pointer;
            background: var(--ion-color-primary, #1c5c7c); color: var(--ion-color-primary-contrast, #fff); }
    .link { border: 0; background: none; padding: 0; cursor: pointer; text-decoration: underline; font-size: 12.5px;
            color: var(--ion-color-primary, #1c5c7c); }
  `],
})
export class SzerkZarSavComponent {
  @Input() zar: SzerkZar | null | undefined = null;

  get ota(): string {
    const k = this.zar?.foglalo?.kezdve;
    if (!k) return '';
    const d = new Date(k);
    if (isNaN(d.getTime())) return '';
    const ma = new Date().toDateString() === d.toDateString();
    const ido = d.toLocaleTimeString('hu-HU', { hour: '2-digit', minute: '2-digit' });
    return ma ? ` ${ido} óta` : ` ${d.toLocaleDateString('hu-HU')} ${ido} óta`;
  }

  async ujratolt() {
    const z = this.zar;
    if (!z?.ujratolt) return;
    try { await z.ujratolt(); } catch { /* a betöltő jelzi */ }
    //  Friss adat van: folytatjuk – a foglaláskor kapott friss zárral, vagy ha a megújításkor veszett el
    //  (a token akkor már törölve), újonnan foglalva.
    if (z.allapot === 'elveszett') { z.allapot = 'kerem'; await z.ujraProbal(); }
  }
}
